/**
 * Where to send a patient after they sign in, when they arrived from somewhere that needed a session
 * first (today: the "Book appointment" link on a public doctor page).
 *
 * Only in-app booking hand-off paths are accepted, so this can never become an open redirect: a value
 * planted in sessionStorage or crafted into a link can at most land the patient on /book/… inside the
 * app. Stored per tab (sessionStorage) and consumed once.
 */
const KEY = 'clinvea.patient.returnTo';
const ALLOWED = /^\/book\/[a-z0-9-]{3,80}\/[a-z0-9-]{3,80}(\?[A-Za-z0-9=&%:._-]*)?$/;

export function isSafeReturnTo(path: string | null | undefined): path is string {
  return typeof path === 'string' && ALLOWED.test(path);
}

export function rememberPatientReturnTo(path: string): void {
  if (!isSafeReturnTo(path)) return;
  try {
    sessionStorage.setItem(KEY, path);
  } catch {
    // Storage unavailable (private mode, blocked): the patient lands on the dashboard instead.
  }
}

/** Returns the saved path once, then forgets it. */
export function consumePatientReturnTo(): string | null {
  try {
    const value = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return isSafeReturnTo(value) ? value : null;
  } catch {
    return null;
  }
}
